import React from 'react';
import './FeaturedTemplesSection.css'; // Import the component-specific styles

function FeaturedTemplesSection() {
  return (
    // Converted HTML to JSX (class -> className)
    <section className="featured-temples-section">
      <div className="section-inner">
        <div className="section-header">
          <h2 className="section-title">Featured Temples</h2>
          <p className="section-subtitle">Participate in rituals at India's most revered shrines.</p>
        </div>
        <div className="temples-grid">
          <div className="temple-card">
            <img alt="Sri Venkateswara Temple" className="temple-image" src="https://lh3.googleusercontent.com/aida-public/AB6AXuCI03ycDyC8yYs0ktX2gTK9wB8mwQHNecHJBfOF4D5mmRjS8sYFt-G66WpS9Rp9OmzBVqhkE61icV2Mz48qq-J3sapJuxnk_MQ3yC0bNWATIhTfJFg_RqEKgAp-p8MEufgoqin6Zsf_sGILd065aV57xNRIpyJkUDE_9rpwxckmtnssfAgSTG028jjg5mJ7yFei24IdkpZRIZXcBe67t7G-fe0IWnuLE7GSkIWwi2CEBG0hUDG4n-icRyQWBb_tknuA8UpCnks01Ty6"/>
            <div className="temple-content">
              <h3 className="temple-title">Sri Venkateswara Temple</h3>
              <p className="temple-location">Tirumala, Andhra Pradesh</p>
            </div>
          </div>
          <div className="temple-card">
            <img alt="Meenakshi Amman Temple" className="temple-image" src="https://lh3.googleusercontent.com/aida-public/AB6AXuCyOUBG_NqR6QAEqG8MwflpQdYOktTbcl1P70VyxvIehSOVfX1slOj_mLZttCgMZ07RYwzZ4chhPPlndjeb6rnRokSUybLBdGQsNRRTw7Lae9E1TRsYkRWhUANH2TH_bajrgTxLbPICYiq06lXi7_EgdPpJl4O4ZWbXyEY9f8VUTdw2RhoGKRYVVQkCKRSuULzNDWjw_hWY3C6_Tr3ikVG01wNSCMz1MEHzLidIBeFdxG8EXYnhJVcvmlqYJZU-arYTpI6npVd_Ieci"/>
            <div className="temple-content">
              <h3 className="temple-title">Meenakshi Amman Temple</h3>
              <p className="temple-location">Madurai, Tamil Nadu</p>
            </div>
          </div>
          <div className="temple-card">
            <img alt="Somnath Temple" className="temple-image" src="https://lh3.googleusercontent.com/aida-public/AB6AXuAbmZ8XKXJ_ihfFKZLTgtIZ_BGzxM9w6p6E9DGlMlHg_L73LijrHxxOR_eYzdn2K96sBx_5qPBzzcSAIrPMkWt_3GYSDjD67pMQ89S5loPAkC5cI5f1E9uuEorWgcZIuifcciUMHac_hRYh2QXzNs3GTiHSPjt5FBIqb2GaYhPI0E5rGX9DqsRvgyxF-tiSx4-l9R66FJz0wbjMVso__Drv2E4MhBI22rRoUonyF6SG7jFsnNW5Q7JIyZbwXxt00PHvj8Tz1NPO7yNN"/>
            <div className="temple-content">
              <h3 className="temple-title">Somnath Temple</h3>
              <p className="temple-location">Veraval, Gujarat</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default FeaturedTemplesSection;
